module.exports = __webpack_public_path__ + "img/style3.8c3627f7.png";